// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuesax from 'vuesax'
import App from './App'
import router from './router'
import store from './stores'
import VueUploadImgs from 'vue-upload-imgs'
import VueClipboard from 'vue-clipboard2'
// i18n
import i18n from './i18n/index'

import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css';
// Vue 2自定义滚动条库仅增强滚动功能
import Vuebar from 'vuebar'
Vue.use(Vuebar)
// Theme Configurations
import VsSidebarGroup from './components/vs-sidebar-group/Sidebar-Group.vue';
Vue.component(VsSidebarGroup.name, VsSidebarGroup);

// 页面显示代码高亮模块
import 'prismjs'
import 'prismjs/themes/prism.css'

import gojs from "gojs"
Vue.prototype.go = gojs

Vue.config.productionTip = false

Vue.use(Vuesax)
Vue.use(VueClipboard)

import {
  Button,
  ButtonGroup,
  Table,
  TableColumn,
  Pagination,
  Drawer,
  DatePicker,
  TimePicker,
  Select,
  Option,
  Input,
  Popover,
  Tooltip,
  Collapse,
  CollapseItem,
  Popconfirm,
  Upload,
  Checkbox,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Card,
  CheckboxGroup,
  Cascader,
  Autocomplete,
  Empty,
} from 'element-ui';

Vue.use(Button);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Drawer);
Vue.use(DatePicker);
Vue.use(TimePicker);
Vue.use(Select);
Vue.use(Option);
Vue.use(Input);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Popconfirm);
Vue.use(Upload);
Vue.use(VueUploadImgs);
Vue.use(Checkbox);

Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Card);
Vue.use(CheckboxGroup);
Vue.use(Cascader);
Vue.use(Autocomplete);
Vue.use(Empty);


// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, PieChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent
} from 'echarts/components';
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  BarChart,
  PieChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent
]);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App),
  template: '<App/>'
}).$mount('#app');

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/scss/style.scss';


import {getRequest} from './utils/http.js'
import {postRequest} from './utils/http.js'
import {deleteRequest} from './utils/http.js'
import {putRequest} from './utils/http.js'
import {uploadFileRequest} from './utils/http.js'
import {downloadFile} from './utils/http.js'



Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;
Vue.prototype.downloadFile = downloadFile;


//枚举的导入
import {sexemus} from "./utils/enums";
import {messageTypeEmus} from "./utils/enums";
import {gradeEmus} from "./utils/enums";
import {loanTypeEmus} from "./utils/enums";
import {repaymentTypeEmus} from "./utils/enums";
import {loanYearsEmus} from "./utils/enums";
import {maritalStatusEmus} from "./utils/enums";
import {buyerDataEmus} from "./utils/enums";
import {sellerDataEmus} from "./utils/enums";
import {followStageEnums} from "./utils/enums";
import {orderStatus2Emus} from "./utils/enums";
import {strategyAllocationEmus} from "./utils/enums";
import {followTypeEmus} from "./utils/enums";
import {followRemindEmus} from "./utils/enums";
import {intermediaryTypeEnums} from "./utils/enums";
import {intermediaryDataEmus} from "./utils/enums";
import {jumpTypeEmus} from "./utils/enums";
import {knowTypeEmus} from "./utils/enums";
import {knowJumpTypeEmus} from "./utils/enums";
import {ruleTypeEnums} from "./utils/enums";
import {symbolTypeEnums} from "./utils/enums";
import {symbolContentTypeEnums} from "./utils/enums";
import {hangupTypeEnums} from "./utils/enums";
import {defaultRuleEnums} from "./utils/enums";
import {smsChannelEnums} from "./utils/enums";
import {taskStatusEnums} from "./utils/enums";
import {weekEnums} from "./utils/enums";
import {tpPhoneGradeEmus} from "./utils/enums";
import {importFilterPhoneStrategyEnums} from "./utils/enums";
import {robotSpeedDataEnums} from "./utils/enums";



Vue.prototype.sexemus = sexemus;
Vue.prototype.messageTypeEmus = messageTypeEmus;
Vue.prototype.gradeEmus = gradeEmus;
Vue.prototype.loanTypeEmus = loanTypeEmus;
Vue.prototype.repaymentTypeEmus = repaymentTypeEmus;
Vue.prototype.loanYearsEmus = loanYearsEmus;
Vue.prototype.maritalStatusEmus = maritalStatusEmus;
Vue.prototype.buyerDataEmus = buyerDataEmus;
Vue.prototype.sellerDataEmus = sellerDataEmus;
Vue.prototype.followStageEnums = followStageEnums;
Vue.prototype.orderStatus2Emus = orderStatus2Emus;
Vue.prototype.strategyAllocationEmus = strategyAllocationEmus;
Vue.prototype.followTypeEmus = followTypeEmus;
Vue.prototype.followRemindEmus = followRemindEmus;
Vue.prototype.intermediaryTypeEnums = intermediaryTypeEnums;
Vue.prototype.intermediaryDataEmus = intermediaryDataEmus;
Vue.prototype.jumpTypeEmus = jumpTypeEmus;
Vue.prototype.knowTypeEmus = knowTypeEmus;
Vue.prototype.knowJumpTypeEmus = knowJumpTypeEmus;
Vue.prototype.ruleTypeEnums = ruleTypeEnums;
Vue.prototype.symbolTypeEnums = symbolTypeEnums;
Vue.prototype.symbolContentTypeEnums = symbolContentTypeEnums;
Vue.prototype.hangupTypeEnums = hangupTypeEnums;
Vue.prototype.defaultRuleEnums = defaultRuleEnums;
Vue.prototype.smsChannelEnums = smsChannelEnums;
Vue.prototype.taskStatusEnums = taskStatusEnums;
Vue.prototype.weekEnums = weekEnums;
Vue.prototype.tpPhoneGradeEmus = tpPhoneGradeEmus;
Vue.prototype.importFilterPhoneStrategyEnums = importFilterPhoneStrategyEnums;
Vue.prototype.robotSpeedDataEnums = robotSpeedDataEnums;



import {gradeText} from "./utils/tools";
import {secondToDate} from "./utils/tools";
import {timeToYYYYMMdd} from "./utils/tools";
import {timeToYYYYMMddhhmmss} from "./utils/tools";
import {getTaskStatusText} from "./utils/tools";
import {openDangerAlert} from "./utils/tools";
import {openSuccessAlert} from "./utils/tools";
import {openAlert} from "./utils/tools";


import {getEnumsTextByValue} from "./utils/tools";
import {getEnumsValueByText} from "./utils/tools";
import {checkPhone} from "./utils/tools";
import {validateIdCard} from "./utils/tools";
import {getAttachContent} from "./utils/tools";
import {getTextByIds} from "./utils/tools";
import {UF} from "./utils/tools";
import {date2str} from "./utils/tools";
import {getWeixinPushContent} from "./utils/tools";
import {getListNameById} from "./utils/tools";
import {getItemById} from "./utils/tools";

import {getCookie} from "./utils/tools";
import {setCookie} from "./utils/tools";
import {delCookie} from "./utils/tools";
import {timeFn} from "./utils/tools";
import {transfertEnter} from "./utils/tools";
import {checkUsername} from "./utils/tools";
import {notifySuccess} from "./utils/tools";
import {notifyDanger} from "./utils/tools";
import {splitIgnoreString} from "./utils/tools";
import {getNameByArrayId} from "./utils/tools";
import {getTextByArrayId} from "./utils/tools";
import {getNickNameByArrayId} from "./utils/tools";
import {checkUrl} from "./utils/tools";
import {getCurrentDate} from "./utils/tools";


Vue.prototype.gradeText = gradeText;
Vue.prototype.secondToDate = secondToDate;
Vue.prototype.timeToYYYYMMdd = timeToYYYYMMdd;
Vue.prototype.timeToYYYYMMddhhmmss = timeToYYYYMMddhhmmss;
Vue.prototype.openDangerAlert = openDangerAlert;
Vue.prototype.openSuccessAlert = openSuccessAlert;
Vue.prototype.openAlert = openAlert;

Vue.prototype.getTaskStatusText = getTaskStatusText;
Vue.prototype.getEnumsTextByValue = getEnumsTextByValue;
Vue.prototype.getEnumsValueByText = getEnumsValueByText;
Vue.prototype.checkPhone = checkPhone;
Vue.prototype.validateIdCard = validateIdCard;
Vue.prototype.getAttachContent = getAttachContent;
Vue.prototype.getTextByIds = getTextByIds;
Vue.prototype.UF = UF;
Vue.prototype.date2str = date2str;
Vue.prototype.getWeixinPushContent = getWeixinPushContent;
Vue.prototype.getListNameById = getListNameById;
Vue.prototype.getItemById = getItemById;
Vue.prototype.timeFn = timeFn;
Vue.prototype.getCookie = getCookie;
Vue.prototype.setCookie = setCookie;
Vue.prototype.delCookie = delCookie;
Vue.prototype.transfertEnter = transfertEnter;
Vue.prototype.checkUsername = checkUsername;
Vue.prototype.notifySuccess = notifySuccess;
Vue.prototype.notifyDanger = notifyDanger;
Vue.prototype.splitIgnoreString = splitIgnoreString;
Vue.prototype.getNameByArrayId = getNameByArrayId;
Vue.prototype.getTextByArrayId = getTextByArrayId;
Vue.prototype.getNickNameByArrayId = getNickNameByArrayId;
Vue.prototype.checkUrl = checkUrl;
Vue.prototype.getCurrentDate = getCurrentDate;


import {SIPml} from './utils/SIPml'
Vue.prototype.SIPml = SIPml;





// WEBPACK FOOTER //
// ./src/main.js